import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EnumIdsTcProvincia, TUsuarioPerfilViewModel, Tc } from '../../../core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { MunicipiosService } from '../../../_mantenimiento/general/municipios/municipios.service';
import { AltaUsuariosExternosService } from '../altausuariosexternos/altausuariosexternos.service';
import { AltaUsuarioExternoViewModel, UsuarioExternoViewModel } from '../altausuariosexternos/altausuariosexternos.types';

@Component({
    selector: 'app-altausuariosexternos-edit',
    templateUrl: './altausuariosexternos-edit.component.html',
    styleUrls: ['./altausuariosexternos-edit.component.scss'],
})
export class AltaUsuariosExternosEditComponent extends ComponentBase implements OnInit {
    editMode: boolean;
    editTitle = 'Nuevo';
    muestroPantallaRegistro = true;
    isMigracion: boolean;
    isCollapsedDatosGen = false;
    isCollapsedDatosRep = false;
    isCollapsedDatosOrg = false;
    isCollapsedDatosContacto = false;
    isCollapsedDatosUser = false;
    isCollapsedTerms = false;
    isRegistro = false;
    isMisDatos = false;
    visibilitySpinner = false;

    listPais: Tc[];
    listProvincia: Tc[];
    listMunicipio: Tc[];
    listTipoVia: Tc[];
    tipo: number;
    listPerfilesSolicitantes: Tc[];
    usuario: AltaUsuarioExternoViewModel;
    localidadTraces: string;
    activo = false;
    nombreUsuario: string;
    fechaCreacion: Date;
    fechaActivacion: Date;
    razonSocial: string;
    nifCifRazonSocial: string;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private municipioService: MunicipiosService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private usuarioService: AltaUsuariosExternosService,
    ) {
        super(authService, notificationService, exceptionHandler);
        this.usuario = new AltaUsuarioExternoViewModel();
        this.usuario.TwUsuarioExterno = new UsuarioExternoViewModel(); //Instanciamos aquí­ en lugar de en el tipo, para no interferir con Usuarios Cexveg.
    }

    ngOnInit() {
        let currentPerfil = new TUsuarioPerfilViewModel();
        this.activatedRoute.data.subscribe(data => (this.tipo = data.tipo));
        currentPerfil.IdPerfil = this.tipo;
        currentPerfil.IdUsuario = this.usuario.Id;

        this.globalService.getPerfilesUsuarioSolicitantes().subscribe(result => {
            this.listPerfilesSolicitantes = result;
            let perfilSeleccionado = this.listPerfilesSolicitantes.find(it => it.Id == this.tipo);
            currentPerfil.Descripcion = perfilSeleccionado!.Descripcion;
        });

        this.globalService.getAllTiposVia().subscribe(res => {
            this.listTipoVia = res;
        });

        //this.listPais$ = this.globalService.getAllPaisesUe(); //Todo:agaro. Cambio a listar los de la UE 29/01/2020
        this.globalService.getPaisesUe().subscribe(res => {
            this.listPais = res;
        });

        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (this.usuario.TUsuarioPerfilCollection == null) {
            this.usuario.TUsuarioPerfilCollection = new Array<TUsuarioPerfilViewModel>();
        }

        this.usuario.TUsuarioPerfilCollection.push(currentPerfil);

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';
            this.muestroPantallaRegistro = false;

            this.isRegistro = false;

            this.usuarioService.getUsuarioExterno(id).subscribe(result => {
                this.usuario = result;

                this.globalService.getProvincias().subscribe(res => {
                    this.listProvincia = res;
                });
                this.globalService.getMunicipios(this.usuario.TwUsuarioExterno?.IdProvincia).subscribe(res => {
                    this.listMunicipio = res;
                });

                this.updateForm();

                this.form.patchValue({
                    Terms: true,
                });

                this.form.controls['Terms'].disable();

                if (this.isEspania()) {
                    if (this.isCeutaMelilla()) {
                        this.form.controls['LocalidadTraces'].enable();
                        this.form.controls['IdMunicipio'].disable();
                    } else {
                        this.form.controls['LocalidadTraces'].disable();
                    }
                } else {
                    this.form.controls['LocalidadTraces'].enable();
                    this.form.controls['IdProvincia'].disable();
                    this.form.controls['IdMunicipio'].disable();
                }

                if (this.activatedRoute.snapshot.data.actionCode == EnumCodigosTwTcAcciones.MISDATOS_USREXTERNO) {
                    this.isMisDatos = true;
                    this.form.controls['Activo'].disable();
                    this.activo = result.Activo;
                    this.localidadTraces = result.TwUsuarioExterno?.LocalidadTraces;
                } else {
                    this.isMisDatos = false;
                    this.activo = result.Activo; //Por si es migración, que podamos coger el activo y mantenerlo al migrar
                    this.nombreUsuario = result.NombreUsuarioCexveg;
                    this.localidadTraces = result.TwUsuarioExterno?.LocalidadTraces;
                    this.razonSocial = result.TwUsuarioExterno?.RazonSocial;
                    this.nifCifRazonSocial = result.TwUsuarioExterno?.NifCifRazonSocial;
                }
            });
        } //ALTA
        else {
            this.editMode = false;
            this.isRegistro = true;
            this.isMisDatos = false;

            this.form.patchValue({
                Activo: false,
            });

            //Deshabilitamos en el alta el campo Activo, que será editado por el mapa o el administrador.
            this.form.controls['Activo'].disable();

            this.isCollapsedTerms = false;

            this.manageOtroPais(); //Para deshabilitar la provincia y municipio de primeras
        }

        this.form.controls['NombreUsuarioCexveg'].disable();
        this.form.controls['FechaCreacion'].disable();
        this.form.controls['FechaActivacion'].disable();
        this.form.controls['FechaBaja'].disable();

        //Contenedores. Abrimos solo el primero.
        //Todo:agaro. 01102019. De primeras todos abiertos a petición del CAU
        this.isCollapsedDatosGen = false;
        this.isCollapsedDatosRep = false;
        this.isCollapsedDatosOrg = false;
        this.isCollapsedDatosContacto = false;
        this.isCollapsedDatosUser = false;
        this.isCollapsedTerms = false;
    }

    private createForm(): void {
        let currentGrupo = this.fb.group({
            Nombre: ['', Validators.required],
            Apellidos: ['', Validators.required],
            Nif: ['', Validators.compose([Validators.required, CustomValidator.NIFValidator])],
            IdPerfil: null,
            NombreUsuarioCexveg: '',
            Activo: false,

            RazonSocial: ['', Validators.required],
            NifCifRazonSocial: ['', Validators.compose([Validators.required, CustomValidator.NIFValidator])],

            IdPais: [null, Validators.required],
            IdProvincia: [null, Validators.required],
            IdMunicipio: [null, Validators.required],
            LocalidadTraces: ['', Validators.required],
            IdTipoVia: null,
            NombreVia: '',
            NumeroPortal: '',
            CodigoPostal: ['', Validators.compose([Validators.required, Validators.pattern('^[0-9]{5}$')])],
            Email: ['', Validators.compose([Validators.required, CustomValidator.emailEmptyValidator])],
            NumeroTelefono: ['', Validators.required],
            NumeroFax: '',
            FechaCreacion: '',
            FechaActivacion: '',
            FechaBaja: '',
            NombreRepresentante: ['', Validators.required],
            ApellidosRepresentante: ['', Validators.required],
            NifRepresentante: ['', Validators.compose([Validators.required, CustomValidator.NIFValidator])],
            Terms: [false, Validators.requiredTrue],
        });

        this.form = currentGrupo;
    }

    private updateForm(): void {
        this.form.setValue({
            Nombre: this.usuario.Nombre,
            Apellidos: this.usuario.Apellidos,
            Nif: this.usuario.Nif,
            Activo: this.usuario.Activo,
            Email: this.usuario.Email,
            NombreUsuarioCexveg: this.usuario.NombreUsuarioCexveg,

            RazonSocial: this.usuario.TwUsuarioExterno?.RazonSocial,
            NifCifRazonSocial: this.usuario.TwUsuarioExterno?.NifCifRazonSocial,
            IdPerfil: null,
            IdPais: this.usuario.TwUsuarioExterno?.IdPais,
            IdProvincia: this.usuario.TwUsuarioExterno?.IdProvincia,
            IdMunicipio: this.usuario.TwUsuarioExterno?.IdMunicipio,
            LocalidadTraces: this.usuario.TwUsuarioExterno?.LocalidadTraces,
            IdTipoVia: this.usuario.TwUsuarioExterno?.IdTipoVia,
            NombreVia: this.usuario.TwUsuarioExterno?.NombreVia,
            NumeroPortal: this.usuario.TwUsuarioExterno?.NumeroPortal,
            CodigoPostal: this.usuario.TwUsuarioExterno?.CodigoPostal,

            NumeroTelefono: this.usuario.TwUsuarioExterno?.NumeroTelefono,
            NumeroFax: this.usuario.TwUsuarioExterno?.NumeroFax,

            FechaCreacion: new Date(this.usuario.FechaCreacion),
            FechaActivacion: this.usuario.FechaActivacion != null ? new Date(this.usuario.FechaActivacion) : '',
            FechaBaja: this.usuario.FechaBaja != null ? new Date(this.usuario.FechaBaja) : '',

            NombreRepresentante: this.usuario.TwUsuarioExterno?.NombreRepresentante,
            ApellidosRepresentante: this.usuario.TwUsuarioExterno?.ApellidosRepresentante,
            NifRepresentante: this.usuario.TwUsuarioExterno?.NifRepresentante,

            Terms: false,
        });
    }

    isEspania(): boolean {
        let config = this.getConfig();
        return this.form.value.IdPais == config.IdPaisEspania;
    }

    isCeutaMelilla(): boolean {
        return this.form.value.IdProvincia == EnumIdsTcProvincia.ID_CEUTA || this.form.value.IdProvincia == EnumIdsTcProvincia.ID_MELILLA;
    }

    onSubmit(): void {
        this.submitted = true;
        let validacionesDeColleccion = false;

        if (this.usuario.TUsuarioPerfilCollection == null || this.usuario.TUsuarioPerfilCollection.length == 0) {
            this.form.patchValue({
                IdPerfil: null,
            });

            this.addValidator('IdPerfil', Validators.required);
            validacionesDeColleccion = true;
        }

        if (!this.form.valid || validacionesDeColleccion) {
            this.addErrorMessage('Revise los datos del Usuario Externo antes de guardar');

            //Abrimos los contenedores.
            this.isCollapsedDatosGen = false;
            this.isCollapsedDatosRep = false;
            this.isCollapsedDatosOrg = false;
            this.isCollapsedDatosContacto = false;
            this.isCollapsedDatosUser = false;

            if (!this.editMode) {
                this.isCollapsedTerms = false;
            }

            return;
        }
        //Se establecen los valores por si no es Migracion
        if (!this.isMigracion) {
            this.razonSocial = this.form.value.RazonSocial;
            this.nifCifRazonSocial = this.form.value.NifCifRazonSocial;
        }

        this.visibilitySpinner = true;
        this.usuario.FechaCreacion = new Date();
        const usuario = this.createUsuarioViewModelFromForm();
        this.saveUserData(usuario);
    }

    private saveUserData(usuario: AltaUsuarioExternoViewModel): void {
        {
            this.usuarioService.createUsuario(usuario).subscribe({
                next: () => {
                    this.addSuccessMessage('Usuario Externo creado correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }

    private createUsuarioViewModelFromForm(): AltaUsuarioExternoViewModel {
        let usuario = new AltaUsuarioExternoViewModel();
        usuario.TwUsuarioExterno = new UsuarioExternoViewModel();

        usuario.Nombre = this.form.value.Nombre;
        usuario.Apellidos = this.form.value.Apellidos;
        usuario.Nif = this.form.value.Nif;
        usuario.Activo = this.activo; //this.form.value.Activo;
        usuario.Email = this.form.value.Email;

        usuario.NombreUsuarioCexveg = this.nombreUsuario;
        usuario.FechaCreacion = this.fechaCreacion;
        usuario.FechaActivacion = this.fechaActivacion;

        usuario.TwUsuarioExterno.RazonSocial = this.razonSocial;
        usuario.TwUsuarioExterno.NifCifRazonSocial = this.nifCifRazonSocial;
        usuario.TwUsuarioExterno.IdPais = this.form.value.IdPais; //+this.getConfig().IdPaisEspania;
        usuario.TwUsuarioExterno.IdProvincia = this.form.value.IdProvincia;
        usuario.TwUsuarioExterno.IdMunicipio = this.form.value.IdMunicipio;

        if (this.isEspania()) {
            if (this.isCeutaMelilla()) {
                usuario.TwUsuarioExterno.LocalidadTraces = this.form.value.LocalidadTraces;
            } else {
                usuario.TwUsuarioExterno.LocalidadTraces = this.localidadTraces;
            }
        } else {
            usuario.TwUsuarioExterno.LocalidadTraces = this.form.value.LocalidadTraces;
        }

        usuario.TwUsuarioExterno.IdTipoVia = this.form.value.IdTipoVia;
        usuario.TwUsuarioExterno.NombreVia = this.form.value.NombreVia;
        usuario.TwUsuarioExterno.NumeroPortal = this.form.value.NumeroPortal;
        usuario.TwUsuarioExterno.CodigoPostal = this.form.value.CodigoPostal;
        usuario.TwUsuarioExterno.NumeroTelefono = this.form.value.NumeroTelefono;
        usuario.TwUsuarioExterno.NumeroFax = this.form.value.NumeroFax;
        usuario.TwUsuarioExterno.NombreRepresentante = this.form.value.NombreRepresentante;
        usuario.TwUsuarioExterno.ApellidosRepresentante = this.form.value.ApellidosRepresentante;
        usuario.TwUsuarioExterno.NifRepresentante = this.form.value.NifRepresentante;

        usuario.Id = this.usuario.Id;
        usuario.TwUsuarioExterno.IdUsuario = this.usuario.Id;

        // Colecciones
        usuario.TUsuarioPerfilCollection = this.usuario.TUsuarioPerfilCollection;

        return usuario;
    }

    private manageEspania(): void {
        this.form.controls['IdProvincia'].enable();
        this.form.controls['IdMunicipio'].enable();

        this.addValidator('IdProvincia', Validators.required);
        this.addValidator('IdMunicipio', Validators.required);

        this.form.controls['LocalidadTraces'].disable();
    }

    private manageOtroPais(): void {
        this.listProvincia = [];
        this.listMunicipio = [];

        this.removeValidators('IdProvincia');
        this.removeValidators('IdMunicipio');
        //this.removeValidators("CodigoPostal");

        this.form.controls['IdProvincia'].disable();
        this.form.controls['IdMunicipio'].disable();

        this.form.controls['LocalidadTraces'].enable();
    }

    onSelectPais(): void {
        if (this.isEspania()) {
            this.manageEspania();
            this.globalService.getProvincias().subscribe(res => {
                this.listProvincia = res;
            });
        } else {
            this.manageOtroPais();
        }

        this.form.patchValue({
            IdProvincia: null,
            IdMunicipio: null,
            LocalidadTraces: '',
        });
    }

    onSelectActivo(): void {
        this.activo = this.form.value.Activo;
    }

    onSelectProvincia(): void {
        const idProvincia = this.form.value.IdProvincia;

        if (this.isCeutaMelilla()) {
            this.removeValidators('IdMunicipio');
            this.form.controls['IdMunicipio'].disable();
            this.form.controls['LocalidadTraces'].enable();
        } else {
            this.globalService.getMunicipios(idProvincia).subscribe(res => {
                this.listMunicipio = res;
            });

            this.addValidator('IdMunicipio', Validators.required);
            this.form.controls['IdMunicipio'].enable();
            this.form.controls['LocalidadTraces'].disable();
        }

        this.form.patchValue({
            IdMunicipio: null,
            LocalidadTraces: '',
        });
    }

    onSelectMunicipio(): void {
        const idMunicipio = this.form.value.IdMunicipio;

        if (idMunicipio > 0) {
            this.municipioService.getMunicipio(idMunicipio).subscribe(result => {
                this.form.patchValue({
                    LocalidadTraces: result.DescripcionTraces,
                });
                this.localidadTraces = result.DescripcionTraces;
            });
        } else {
            this.form.patchValue({
                LocalidadTraces: '',
            });
            this.localidadTraces = '';
        }
    }

    onBack(): void {
        if (!this.editMode) {
            //if (this.muestroPantallaRegistro) {
            //    //voy a la home
            //    this.router.navigate(['/home']);
            //} else {
            //    //es como volver a la 'pantalla' Registro
            //    this.muestroPantallaRegistro = true;
            //}

            this.createForm();
        } else {
            this.router.navigate(['/sede/asistentes/altausuariosexternos']);
        }
    }

    onAcceptDialogUsuarioExterno(usuarioCexvegSL: AltaUsuarioExternoViewModel): void {
        this.form.setValue({
            Nombre: usuarioCexvegSL?.Nombre,
            Apellidos: usuarioCexvegSL?.Apellidos,
            Nif: usuarioCexvegSL?.Nif,
            Activo: usuarioCexvegSL?.Activo,
            Email: usuarioCexvegSL?.Email,
            NombreUsuarioCexveg: usuarioCexvegSL?.NombreUsuarioCexveg,
            RazonSocial: usuarioCexvegSL?.TwUsuarioExterno?.RazonSocial,
            NifCifRazonSocial: usuarioCexvegSL?.TwUsuarioExterno?.NifCifRazonSocial,
            IdPerfil: null,
            IdPais: usuarioCexvegSL?.TwUsuarioExterno?.IdPais,
            IdProvincia: usuarioCexvegSL?.TwUsuarioExterno?.IdProvincia,
            IdMunicipio: usuarioCexvegSL?.TwUsuarioExterno?.IdMunicipio,
            LocalidadTraces: usuarioCexvegSL?.TwUsuarioExterno?.LocalidadTraces,
            IdTipoVia: usuarioCexvegSL?.TwUsuarioExterno?.IdTipoVia,
            NombreVia: usuarioCexvegSL?.TwUsuarioExterno?.NombreVia,
            NumeroPortal: usuarioCexvegSL?.TwUsuarioExterno?.NumeroPortal,
            CodigoPostal: usuarioCexvegSL?.TwUsuarioExterno?.CodigoPostal,
            NumeroTelefono: usuarioCexvegSL?.TwUsuarioExterno?.NumeroTelefono,
            NumeroFax: usuarioCexvegSL?.TwUsuarioExterno?.NumeroFax,
            FechaCreacion: new Date(usuarioCexvegSL?.FechaCreacion),
            FechaActivacion: usuarioCexvegSL?.FechaActivacion != null ? new Date(usuarioCexvegSL?.FechaActivacion) : '',
            FechaBaja: usuarioCexvegSL?.FechaBaja != null ? new Date(usuarioCexvegSL?.FechaBaja) : '',
            NombreRepresentante: usuarioCexvegSL?.TwUsuarioExterno?.NombreRepresentante,
            ApellidosRepresentante: usuarioCexvegSL?.TwUsuarioExterno?.ApellidosRepresentante,
            NifRepresentante: usuarioCexvegSL?.TwUsuarioExterno?.NifRepresentante,
            Terms: false,
        });

        this.form.controls['RazonSocial'].disable();
        this.form.controls['NifCifRazonSocial'].disable();

        this.activo = usuarioCexvegSL?.Activo;
        this.nombreUsuario = usuarioCexvegSL?.NombreUsuarioCexveg;
        this.fechaCreacion = usuarioCexvegSL?.FechaCreacion;
        this.fechaActivacion = usuarioCexvegSL?.FechaActivacion;
        this.localidadTraces = usuarioCexvegSL?.TwUsuarioExterno?.LocalidadTraces;
        this.razonSocial = usuarioCexvegSL?.TwUsuarioExterno?.RazonSocial;
        this.nifCifRazonSocial = usuarioCexvegSL?.TwUsuarioExterno?.NifCifRazonSocial;

        this.onSelectPais();

        this.form.patchValue({
            IdProvincia: usuarioCexvegSL?.TwUsuarioExterno?.IdProvincia,
        });

        this.onSelectProvincia();

        this.isMigracion = true;
    }

    // PERFILES
    onAddPerfil(): void {
        if (this.form.value.IdPerfil != null && this.form.value.IdPerfil > 0) {
            this.removeValidators('IdPerfil');
            this.addValidator('IdPerfil', Validators.required);

            if (this.isFieldInvalidNoSubmit('IdPerfil', 'required')) {
                return;
            }

            this.removeValidators('IdPerfil');

            if (this.usuario.TUsuarioPerfilCollection == null) {
                this.usuario.TUsuarioPerfilCollection = new Array<TUsuarioPerfilViewModel>();
            }

            // Comprobamos que no esté ya incluido
            let yaIncluido = this.usuario.TUsuarioPerfilCollection.find(it => it.IdPerfil == this.form.value.IdPerfil);

            if (yaIncluido) {
                this.addWarningMessage('El perfil seleccionado ya estaba incluido.');
                return;
            }

            let currentPerfil = new TUsuarioPerfilViewModel();
            currentPerfil.IdPerfil = this.form.value.IdPerfil;
            currentPerfil.IdUsuario = this.usuario.Id;

            // Si no está incluido todavía, actualizamos el listbox
            let perfilSeleccionado = this.listPerfilesSolicitantes.find(it => it.Id == this.form.value.IdPerfil);
            currentPerfil.Descripcion = perfilSeleccionado!.Descripcion;

            this.usuario.TUsuarioPerfilCollection.push(currentPerfil);

            this.removeValidators('IdPerfil');

            this.form.patchValue({
                IdPerfil: null,
            });
        } else {
            this.addWarningMessage('Primero ha de seleccionarse un perfil de la lista.');
        }
    }

    onDeletePerfil(item: TUsuarioPerfilViewModel): void {
        this.usuario.TUsuarioPerfilCollection.splice(this.usuario.TUsuarioPerfilCollection.indexOf(item), 1);
    }

    private loadPerfilesSolicitante(): void {
        this.globalService.getPerfilesUsuarioSolicitantes().subscribe(result => {
            this.listPerfilesSolicitantes = result;
        });
    }

    get readonly(): boolean {
        return this.loggedInUser !== null && !this.isAdmin && this.editMode;
    }

    get readonlyForAdmin(): boolean {
        return this.loggedInUser !== null && this.isAdmin;
    }
}
